import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { projectsKeys } from './projects.key';
import { toast } from '../../../components/Toast';

export function useRenameProject() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({
    projectId,
    name,
  }: {
    projectId: string;
    name: string;
  }) => {
    const api = await getApi();
    const res = await api.projectsUpdateProject(projectId, { name });
    return res.data;
  };

  const onSuccess = () => {
    toast.success('Projektet uppdaterat');
    queryClient.invalidateQueries({ queryKey: projectsKeys.all });
  };

  const onError = () => {
    toast.error('Något gick fel');
  };

  const mutation = useMutation({
    mutationFn,
    onSuccess,
    onError,
  });

  return mutation;
}
